import {adminApi} from 'sources/api';
import IntegrationDataInfo from 'records/IntegrationDataInfo';

export class AdminIntegrationSource {
  static retrieve() {
    return adminApi
      .getJson(`/integrations`)
      .then(infos => infos.map(it => new IntegrationDataInfo(it)));
  }
}
